import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormHelperService {
  public checkFormFields(group: UntypedFormGroup): void {
    Object.keys(group.controls).forEach((field: string) => {
      const control: AbstractControl = group.get(field);
      try {
        control?.markAsTouched({ onlySelf: true });
      } catch {
        return;
      }
    });
  }

  public setFormFieldsEnabled(group: UntypedFormGroup, enabled: boolean): void {
    Object.keys(group.controls).forEach((field: string) => {
      const control: AbstractControl = group.get(field);
      try {
        if (control) {
          if (!enabled) {
            control.disable();
          } else {
            control.enable();
          }
        }
      } catch {
        return;
      }
    });
  }

  public removeBlankFields(obj: Record<string, string | null>): Record<string, any> {
    const result: Record<string, any> = {};
    for (const key in obj) {
      const value: string = obj[key];
      if (value !== '' || value == null) {
        result[key] = value;
      }
    }
    return result;
  }
}
